<div class="fullcontainer pr-3">
  <div class="sheet">
    <div class="titleContainer">
      <h1 class="header">Report Builder - {{ this.schema?.label || this.entityKey }}</h1>
      <div>
        <button class="btn btn-secondary" routerLink="/report-builder">All Report Builders</button>
      </div>
    </div>

    @if (this.loadFailed) {
      <div class="alert alert-danger mb-0">
        <strong>Could not load this report.</strong> The entity may not be reportable, or the schema failed to load.
      </div>
    }

    @if (this.schema) {
      <p class="text-muted">
        Pick which columns to show and which related records to join, then run the report.
        Filtering, sorting, pagination and CSV export all work directly on the results below.
      </p>

      @if (this.savedReports.length > 0) {
        <div class="row">
          <div class="col-md-6">
            <label>Saved reports for {{ this.schema.label }}</label>
            <select class="form-control" [ngModel]="this.selectedSavedReportId"
              (ngModelChange)="this.loadSavedReport($event)">
              <option [ngValue]="-1">Choose a saved report&hellip;</option>
              @for (report of this.savedReports; track report.id) {
                <option [ngValue]="report.id">{{ report.name }}</option>
              }
            </select>
          </div>
        </div>
        <br>
      }

      <div class="row">
        <div class="col-md-6">
          <label>Report name</label>
          <input type="text" class="form-control" [(ngModel)]="this.reportName" placeholder="Name this report to save it">
        </div>
        <div class="col-md-6 d-flex align-items-end">
          <button class="btn btn-secondary mr-2" (click)="this.saveReport()" [disabled]="this.saving || !this.reportName">
            {{ this.currentSavedReport ? 'Update Saved Report' : 'Save Report' }}
          </button>
          @if (this.currentSavedReport) {
            <button class="btn btn-secondary mr-2" (click)="this.newReport()">New</button>
            <button class="btn btn-danger" (click)="this.deleteSavedReport()">Delete</button>
          }
        </div>
      </div>

      @if (this.saveFailed) {
        <div class="alert alert-danger mb-0 mt-2">The report could not be saved.</div>
      }

      <br>

      <div class="row">
        <div class="col-md-6">
          <label>Columns</label>
          <div class="report-builder-picker">
            @for (column of this.schema.columns; track column.key) {
              <div class="form-check">
                <input type="checkbox" class="form-check-input" [id]="'col-' + column.key"
                  [checked]="this.activeColumnKeys[column.key]" (change)="this.toggleColumn(column.key)">
                <label class="form-check-label" [for]="'col-' + column.key">{{ column.label }}</label>
              </div>
            }
          </div>
        </div>

        @if (this.schema.basicRelationships.length > 0) {
          <div class="col-md-6">
            <label>Joined records</label>
            <div class="report-builder-picker">
              @for (relationship of this.schema.basicRelationships; track relationship) {
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" [id]="'rel-' + relationship"
                    [checked]="this.activeRelationships[relationship]" (change)="this.toggleRelationship(relationship)">
                  <label class="form-check-label" [for]="'rel-' + relationship">{{ relationship }}</label>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <br>
      <button class="btn btn-primary" (click)="this.runReport()">Run Report</button>
    }
  </div>

  @if (this.built) {
    <div class="sheet">
      <app-grid
        [entity]="this.schema.basicEntity"
        [columns]="this.columns"
        [relationships]="this.relationships"
        [searchFields]="this.searchFields"
        [searchFilters]="this.searchFilters">
      </app-grid>
    </div>
  }
</div>
